import { Link } from "@/components/common/Link";
export default function SupportAssistance() {
  return <section id="support-assistance" className="relative overflow-hidden border-t border-white/5 bg-[#0b0e14] py-16">
      <div className="container relative z-10 mx-auto px-4 text-center">
        <p className="text-base text-white/70 md:text-lg">
          Need assistance with setup or billing? Contact the Imperium Technologies team.{" "}
          <Link to="/support" className="relative inline-block font-medium text-primary after:absolute after:bottom-0 after:left-0 after:h-[1px] after:w-full after:origin-bottom-right after:scale-x-0 after:bg-primary after:transition-transform after:duration-300 hover:after:origin-bottom-left hover:after:scale-x-100">
            Contact Support
          </Link>
        </p>
      </div>
    </section>;
}